export enum PROVIDER_ID {
  APPLE_PROVIDER_ID = 'apple.com',
  GOOGLE_PROVIDER_ID = 'google.com',
  EMAIL_PROVIDER_ID = 'password',
  FACEBOOK_PROVIDER_ID = 'facebook.com',
}
